<div class="password-validation">
  <ftr-password-strength-meter [passwordStrength]="passwordStrength"></ftr-password-strength-meter>

  <ftr-password-validation-feedback
    [validationErrors]="validationErrors"
    [confirmPasswordValidationErrors]="confirmPasswordValidationErrors"
    [formStatusChanges$]="formStatusChanges$"
  ></ftr-password-validation-feedback>
</div>
